export default __webpack_public_path__ + "static/axesCheck_PAC_Banner_illu-03-5777ac2f224c0a4598d843ac8f07de01.svg";